/**
 * @file Defines the {@link UI_BET_DOM_CONFIG} constant
 * @author Joe Thompson <joe.thompson@1x2gaming.com>
 */

/**
 * Config for UI DOM structure.
 * @type {ui-dom-config[]}
 * @constant
 */

 const UI_BET_DOM_CONFIG = [

    {

        id: 'betContainerMobile',
        element:   'div',
        classList: ['mobileInterface'],
        siblings: [

            {

                id: 'bet-header',
                element:   'div',
                classList: ['header'],
                siblings: [

                    {

                        id: 'bet-header-text',
                        element:   'div',
                        classList: ['header-text']

                    },

                    {

                        id: 'bet-header-close',
                        element:   'div',
                        classList: ['header-close']

                    }

                ]
                
            },

            {
                
                id: 'bet-body',
                element:   'div',
                classList: ['body'],
                siblings: [

                    {

                        id: 'bet-close',
                        element: 'button',
                        classList: [ 'button', 'interface-close-button' ],
                        siblings: []

                    },

                    {

                        id: 'bet-input',
                        element:   'div',
                        classList: ['input'],
                        siblings: [

                            {

                                id: 'bet-range-input',
                                element:   'div',
                                classList: ['range-input'],
                                siblings: [

                                    {

                                        id: 'bet-minus-button',
                                        element: 'div',
                                        classList: ['minus-button'],
                                        siblings: [

                                            {

                                                id: 'bet-minus',
                                                element:   'button',
                                                classList: ['roundButton', 'minus'],
        
                                            }

                                        ]

                                    },
                                    {

                                        id: 'bet-amount',
                                        element:   'div',
                                        classList: ['amount']

                                    },

                                    {

                                        id: 'bet-plus-button',
                                        element: 'div',
                                        classList: ['plus-button'],
                                        siblings: [

                                            {

                                                id: 'bet-plus',
                                                element:   'button',
                                                classList: ['roundButton', 'plus'],
        
                                            }

                                        ]

                                    }

                                ]

                            },

                            {

                                id: 'max-bet',
                                element:   'div',
                                classList: [],
                                siblings: [

                                    {
                                        id: 'max-bet-button',
                                        element: 'button',
                                        classList: []
                                    }

                                ]

                            }

                        ]

                    },

                    {
                        
                        id: 'body-settings',
                        element:   'div',
                        classList: [],
                        siblings: [

                            {

                                id: 'buttons',
                                element: 'div',
                                classList: [],
                                siblings: [

                                    {
                                        id: 'coins',
                                        element:   'button',
                                        classList: ['settingsButton']
                                    },
                                    {
                                        id: 'cash',
                                        element:   'button',
                                        classList: ['settingsButton']
                                    }

                                ]

                            }

                        ]

                    }

                ]

            }

        ]

    }

 ]

 export { UI_BET_DOM_CONFIG }